'use client'

import { useSchedule } from '@/src/lib/hooks/useSchedule'
import { Clock } from 'lucide-react'
import { ErrorBoundary } from 'next/dist/client/components/error-boundary'
import { Suspense } from 'react'
import { SilentErrorFallback } from '../common/silent-error-boundary'

function HomeScheduleContent() {
  const { data: schedule } = useSchedule()

  return (
    <div className="flex items-start gap-3">
      <Clock className="text-srperrito-dark mt-1 flex-shrink-0" />
      <div className="w-full h-auto">
        {schedule?.days?.map((hour, index) => (
          <div key={index} className="mb-3 last:mb-0">
            <div className="font-medium text-srperrito-dark mb-1">{hour.days}</div>
            {hour.shifts.length === 1
              ? (
                  <div className="text-gray-600">{hour.shifts[0]}</div>
                )
              : (
                  <div className="grid grid-cols-2 gap-2">
                    {hour.shifts.map((shift, shiftIndex) => (
                      <div key={shiftIndex} className="text-gray-600">{shift}</div>
                    ))}
                  </div>
                )}
          </div>
        ))}
        <p className="text-xs text-gray-500 mt-3 italic">*Nuestros horarios pueden cambiar en fechas específicas, te recomendamos verificar los mismos desde Google Maps.</p>
      </div>
    </div>
  )
}

function HomeScheduleFallback() {
  return (
    <div className="text-gray-600">
      Cargando horarios...
    </div>
  )
}

export function HomeSchedule() {
  return (
    <ErrorBoundary errorComponent={SilentErrorFallback}>
      <Suspense fallback={<HomeScheduleFallback />}>
        <HomeScheduleContent />
      </Suspense>
    </ErrorBoundary>
  )
}
